<template>
  <article>
    <span v-for="(detail, key) in DetailList" :key="key">
      <div class="text-lg-right text-center">
        <small>{{ detail.namFam }}</small> &nbsp; <small class="font-weight-bold float-lg-left text-center" :class="setTextColor(detail.tblcomboGrp101Vaziat)">[{{ detail.tblcomboGrp101VaziatName }}]</small>
      </div>
    </span>
  </article>
</template>
<script>
export default {
  data() {
    return {
        // rows:[],
        // TblGrpIdUserRequested:0
    }
  },
  props: ['DetailList', 'GetGrpUserInserted'],
  methods: {
    setTextColor(tblcomboGrp101Vaziat) {
      if (tblcomboGrp101Vaziat == 1085232) {
        return 'text-danger'
      }
      if (tblcomboGrp101Vaziat == 1085233) {
        return 'text-warning'
      }
      if (tblcomboGrp101Vaziat == 1085234) {
        return 'text-success'
      }
    },
    GetData() {
      
    },
  },
  created() {
  },
}
</script>
